import { render, staticRenderFns } from "./Usc_BAN01_AT05_R1.vue?vue&type=template&id=c3c1c54e"
import script from "./Usc_BAN01_AT05_R1.vue?vue&type=script&lang=js"
export * from "./Usc_BAN01_AT05_R1.vue?vue&type=script&lang=js"
import style0 from "./Usc_BAN01_AT05_R1.vue?vue&type=style&index=0&id=c3c1c54e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports